import intl from "react-intl-universal";
import {
  TbCalendarEvent,
  TbCash,
  TbCirclePlus,
  TbCreditCard,
  TbPercentage,
  TbSettings,
} from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { useBaasCapabilities } from "../../../../../Hooks/useBaasCapabilities";
import { BaasFundShellsButton } from "../../Accounts/components/BaasFundShellsButton";
import {
  BAAS_CARTOES_ACCOUNTS_PATH,
  BAAS_CARTOES_CREDITO_PATH,
  BAAS_CARTOES_REBATE_PATH,
  BAAS_CARTOES_SETTLEMENT_PATH,
  BAAS_CARTOES_SETTINGS_PATH,
} from "../../constants";
import { CARTOES_CREATE_PATH } from "../BaasCardProgramCreatePage";

const QUICK_ACTIONS = [
  {
    id: "settings",
    labelKey: "baas.cartoes.quickActions.settings",
    icon: TbSettings,
    to: BAAS_CARTOES_SETTINGS_PATH,
  },
  {
    id: "accounts",
    labelKey: "baas.cartoes.quickActions.accounts",
    icon: TbCreditCard,
    to: BAAS_CARTOES_ACCOUNTS_PATH,
  },
  {
    id: "settlement",
    labelKey: "baas.cartoes.quickActions.settlement",
    icon: TbCalendarEvent,
    to: BAAS_CARTOES_SETTLEMENT_PATH,
  },
  {
    id: "rebate",
    labelKey: "baas.cartoes.quickActions.rebate",
    icon: TbPercentage,
    to: BAAS_CARTOES_REBATE_PATH,
  },
  {
    id: "credito",
    capabilityId: "credit.panel.view",
    labelKey: "baas.cartoes.quickActions.credito",
    icon: TbCash,
    to: BAAS_CARTOES_CREDITO_PATH,
  },
  {
    id: "create",
    capabilityId: "issuer.programs.create",
    labelKey: "baas.cartoes.quickActions.createProgram",
    icon: TbCirclePlus,
    to: CARTOES_CREATE_PATH,
    write: true,
  },
];

export const BaasCartoesQuickActions = () => {
  const { can } = useBaasCapabilities();

  const visibleActions = QUICK_ACTIONS.filter(({ capabilityId }) => {
    if (!capabilityId) return true;
    return can(capabilityId);
  });

  const showFundShells = can("accounts.transfer");

  if (!visibleActions.length && !showFundShells) {
    return null;
  }

  return (
    <section className="baas-cartoes-quick-actions min-w-0 w-full">
      <p className="dashboard-section-label mb-3">
        {intl.get("baas.cartoes.quickActionsSection")}
      </p>
      <div className="shortcut-scroll-row">
        {visibleActions.map(({ id, labelKey, icon, to }) => (
          <ShortcutCard
            key={id}
            to={to}
            icon={icon}
            label={intl.get(labelKey)}
          />
        ))}
        {showFundShells ? <BaasFundShellsButton variant="shortcut" /> : null}
      </div>
    </section>
  );
};
